module.exports = __webpack_public_path__ + "assets/img/driver-btn-b6122667.png";